module.exports = __webpack_public_path__ + "img/layout_rows.1e178fb2.png";